import { createActionGroup, props } from '@ngrx/store';
import { AddUsersProps, DeleteInvitedUserProps } from './department-users-admin.props';

export const departmentUsersAdminActions = createActionGroup({
  source: 'DepartmentUsersAdmin',
  events: {
    'Add users': props<AddUsersProps>(),
    'Delete invited user': props<DeleteInvitedUserProps>(),
  },
});
